import useLenis from "../hooks/useLenis";
import { SHOW_MEDIA } from "../data";
import Nav from "../components/site/Nav";
import Hero from "../components/site/Hero";
import Marquee from "../components/site/Marquee";
import Services from "../components/site/Services";
import Story from "../components/site/Story";
import Gallery from "../components/site/Gallery";
import InstagramFeed from "../components/site/InstagramFeed";
import BeforeAfter from "../components/site/BeforeAfter";
import Booking from "../components/site/Booking";
import Footer from "../components/site/Footer";
import WhatsAppFloat from "../components/site/WhatsAppFloat";

export default function Landing() {
  useLenis();
  return (
    <div className="bg-white text-ink overflow-x-hidden">
      <Nav />
      <main>
        <Hero />
        <Marquee />
        <Services />
        <Story />
        {SHOW_MEDIA && <BeforeAfter />}
        {SHOW_MEDIA && <Gallery />}
        {SHOW_MEDIA && <InstagramFeed />}
        <Booking />
      </main>
      <Footer />
      <WhatsAppFloat />
    </div>
  );
}
